import { useState } from "react";
import { Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Button } from "antd";

const ALLOWED_HOSTS = ["localhost", "127.0.0.1", "my.nextgis.dev"];

const ThrowOnRender = () => {
  throw new Error("Test: synchronous render error");
};

export const TestErrorsPage = () => {
  const [renderError, setRenderError] = useState(false);

  if (!ALLOWED_HOSTS.includes(window.location.hostname)) {
    return <Navigate to="/" replace />;
  }

  if (renderError) {
    return <ThrowOnRender />;
  }

  const handleSyncError = () => {
    throw new Error("Test: synchronous click handler error");
  };

  const handlePromiseError = () => {
    Promise.reject(new Error("Test: unhandled promise rejection"));
  };

  const handleManualCapture = () => {
    Sentry.captureException(new Error("Test: manually captured Sentry exception"));
    alert("Exception sent to Sentry via captureException()");
  };

  const handleManualMessage = () => {
    Sentry.captureMessage("Test: manual Sentry message", "warning");
    alert("Message sent to Sentry via captureMessage()");
  };

  return (
    <div className="page" style={{ maxWidth: 720 }}>
      <h1 style={{ marginBottom: 4 }}>Sentry Error Test Page</h1>
      <p style={{ color: "rgba(0,0,0,0.45)", marginBottom: 32 }}>
        Only visible on localhost and my.nextgis.dev
      </p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ marginBottom: 8 }}>Unhandled errors</h2>
        <p style={{ color: "rgba(0,0,0,0.45)", marginBottom: 12 }}>
          These errors are not caught — Sentry should capture them automatically
          via its global error boundary / event listeners.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          <Button danger onClick={handleSyncError}>
            Throw in click handler
          </Button>
          <Button danger onClick={handlePromiseError}>
            Unhandled promise rejection
          </Button>
          <Button danger onClick={() => setRenderError(true)}>
            Throw in render
          </Button>
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ marginBottom: 8 }}>Manual capture</h2>
        <p style={{ color: "rgba(0,0,0,0.45)", marginBottom: 12 }}>
          These call the Sentry SDK directly and should always appear in your
          Sentry dashboard regardless of error boundary configuration.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          <Button onClick={handleManualCapture}>
            captureException()
          </Button>
          <Button onClick={handleManualMessage}>
            captureMessage()
          </Button>
        </div>
      </section>
    </div>
  );
};
